// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperModal-cls1__li","cls2":"MultiPaperModal-cls2_dKB MultiPaperModal-cls1__li"};